/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PatientNoteDto } from '../model';
/**
 * PatientNoteApiControllerApi - axios parameter creator
 * @export
 */
export const PatientNoteApiControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PatientNoteDto} patientNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNote: async (patientNoteDto: PatientNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientNoteDto' is not null or undefined
            assertParamExists('addNote', 'patientNoteDto', patientNoteDto)
            const localVarPath = `/api/patient-note/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} visitPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoteByVisitPublicId: async (visitPublicId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitPublicId' is not null or undefined
            assertParamExists('getNoteByVisitPublicId', 'visitPublicId', visitPublicId)
            const localVarPath = `/api/patient-note/{visitPublicId}`
                .replace(`{${"visitPublicId"}}`, encodeURIComponent(String(visitPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PatientNoteDto} patientNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNote: async (id: number, patientNoteDto: PatientNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateNote', 'id', id)
            // verify required parameter 'patientNoteDto' is not null or undefined
            assertParamExists('updateNote', 'patientNoteDto', patientNoteDto)
            const localVarPath = `/api/patient-note/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientNoteApiControllerApi - functional programming interface
 * @export
 */
export const PatientNoteApiControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientNoteApiControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PatientNoteDto} patientNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addNote(patientNoteDto: PatientNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addNote(patientNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} visitPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNoteByVisitPublicId(visitPublicId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PatientNoteDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNoteByVisitPublicId(visitPublicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {PatientNoteDto} patientNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNote(id: number, patientNoteDto: PatientNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNote(id, patientNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PatientNoteApiControllerApi - factory interface
 * @export
 */
export const PatientNoteApiControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientNoteApiControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PatientNoteDto} patientNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNote(patientNoteDto: PatientNoteDto, options?: any): Promise<number> {
            return localVarFp.addNote(patientNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} visitPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNoteByVisitPublicId(visitPublicId: string, options?: any): Promise<PatientNoteDto> {
            return localVarFp.getNoteByVisitPublicId(visitPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {PatientNoteDto} patientNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNote(id: number, patientNoteDto: PatientNoteDto, options?: any): Promise<void> {
            return localVarFp.updateNote(id, patientNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientNoteApiControllerApi - object-oriented interface
 * @export
 * @class PatientNoteApiControllerApi
 * @extends {BaseAPI}
 */
export class PatientNoteApiControllerApi extends BaseAPI {
    /**
     * 
     * @param {PatientNoteDto} patientNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientNoteApiControllerApi
     */
    public addNote(patientNoteDto: PatientNoteDto, options?: AxiosRequestConfig) {
        return PatientNoteApiControllerApiFp(this.configuration).addNote(patientNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} visitPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientNoteApiControllerApi
     */
    public getNoteByVisitPublicId(visitPublicId: string, options?: AxiosRequestConfig) {
        return PatientNoteApiControllerApiFp(this.configuration).getNoteByVisitPublicId(visitPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {PatientNoteDto} patientNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientNoteApiControllerApi
     */
    public updateNote(id: number, patientNoteDto: PatientNoteDto, options?: AxiosRequestConfig) {
        return PatientNoteApiControllerApiFp(this.configuration).updateNote(id, patientNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}
